import { onValue, ref } from "firebase/database";
import React, { useEffect, useState } from "react";
import { db } from "../../../firebaseConfig";
import ClientCard from "../components/ClientCard";
import "./Clients.css";

export default function Clients() {
  const [clientsData, setClientsData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Subscribe to real-time updates
    const starCountRef = ref(db, "users");
    const unsubscribe = onValue(starCountRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setClientsData(Object.values(data));
      }
    });
    // Cleanup the subscription on component unmount
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <div className="clients">
      <div className="clients-container">
        <h2>Clients.</h2>
        <div className="clients-list">
          {clientsData.map(
            (
              {
                photoURL,
                displayName,
                paid,
                physicalSessions,
                voiceSessions,
                videoSessions,
                uid,
              },
              index
            ) => (
              <ClientCard
                key={index}
                img={photoURL}
                uid={uid}
                name={displayName}
                paid={paid || 0}
                physicalSessions={physicalSessions || 0}
                voiceSessions={voiceSessions || 0}
                videoSessions={videoSessions || 0}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
}
